import _Box from "@material-ui/core/esm/Box";
import React from 'react';
import { GiveawayLandingSubtitle } from '../giveaway-landing-subtitle';
import classes from './giveaway-landing-catalog-subtitle.scss';
export const GiveawayLandingCatalogSubtitle = ({
  budget,
  budgetColor
}) => {
  return /*#__PURE__*/React.createElement(GiveawayLandingSubtitle, {
    className: classes.title
  }, /*#__PURE__*/React.createElement(_Box, null, "You have a budget of", ' ', /*#__PURE__*/React.createElement("span", {
    className: classes.primary,
    style: {
      color: budgetColor
    }
  }, budget), ' ', "to spend!"), /*#__PURE__*/React.createElement(_Box, null, "Please select the products you want!"));
};